import React from "react";

import Header from '../components/header';
import Footer from '../components/footer';

function Blog() {
  return (
    <div>
      <Header />
      <Footer />
    </div>
  );
}


export default Blog;